import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Series from "../pages/series/page";
import Calendar from "../pages/calendar/page";
import About from "../pages/about/page";
import AnimeDetail from "../pages/anime/detail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/series",
    element: <Series />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/anime/:id",
    element: <AnimeDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;